import { ajaxGetJson, ajaxPostJson, setParams } from './ajax';

// 源语言与目标语言
export const queryProjectDetails = (params) => {
  return ajaxPostJson(`/project/queryProjectTermMemoryList`, params);
};

// file组件下
// 根据ID查询文件列表
export const queryFileByProjectID = (params) => {
  return ajaxPostJson(`/project/queryFile`, params);
};

// 分页查询文件列表
export const queryFilePageByProjectID = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`/project/queryFilePageByProjectId`, params);
};

// 根据ID删除文件
export const deleteFileByProjectID = (params) => {
  return ajaxPostJson(`/file/deleteFile`, params);
};

// 根据ID删除多个文件
export const deleteFilesByProjectID = (params) => {
  return ajaxPostJson(`/file/deleteFiles`, params);
};

// 查询项目信息
export const queryTransProject = (params) => {
  return ajaxPostJson(`/project/get_transProject`, params);
};

// 轮询项目信息
export const checkTransStatus = (params) => {
  return ajaxPostJson(`/project/check_trans_status`, params);
};

// 上传项目文件
export const addProjectFiles= (params) => {
  return ajaxPostJson(`/file/add_files`, params);
};

// 保存项目信息
export const updateTransProject = (params) => {
  return ajaxPostJson(`/project/updateTransProject`, params);
};

// 轮询下载
export const getDownloadAsyncResult = (params) => {
  params = setParams(params);
  return ajaxGetJson(`/file/getDownloadAsyncResult?taskKey=${params.taskKey}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
};

// 轮询下载 主要用于项目文件列表QA下载
export const getDownloadAsyncResultV2 = (params) => {
  params = setParams(params);
  return ajaxGetJson(`/file/getDownloadAsyncResultV2?taskKey=${params.taskKey}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
};

// 下载tmx文件
export const exportTransFileTmx = (params) => {
  return ajaxPostJson(`/file/exportTransFileTmx`, params);
};

// 下载xlf文件
export const exportTransFileXlf = (params) => {
  return ajaxPostJson(`/file/exportTransFileXlf`, params);
};

// 首先请求下载
export const exportAsyncTransFile = (params) => {
  params = setParams(params);
  return ajaxGetJson(`/file/exportAsyncTransFile?type=${params.type}&fileId=${params.fileId}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
};

// 首先请求V2 主要用于项目文件列表QA下载
export const downloadAsyncV2 = (params) => {
  params = setParams(params);
  return ajaxGetJson(`/file/downloadAsyncV2?type=${params.type}&fileId=${params.fileId}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
}

// 文件查看按钮检查是否拆分
//如果已分配任务且只分配一个人就获取taskId
export const taskList = (params) => {
  return ajaxPostJson(`/fileTask/task_list`, params);
};

// 离线更新原文
export const fileRepeatHandler = (params) => {
  return ajaxPostJson(`/file/file_repeat_handler`, params);
};